import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BaseService } from '@projects/shared-lib/src/lib/services/base-http.service';
import { environment } from 'src/environments/environment';
//import { AuthTokenInterceptor } from './auth-token.interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  //readonly SCOPE = ["user.read"];
  SCOPE = [environment.AUTH_RESOURCE_LINK.webAPI];

  constructor(private msalAuthService: MsalService) { }

  public async getTokenFromMSAL(url, forceFlag = false): Promise<Object> {
    console.log('In getTokenFromMSAL');
    if (url.indexOf('/logout') > -1) {
      return 'logout-token';
    }
    if (url.indexOf('graph.microsoft.com') > -1) {
      this.SCOPE = ["user.read"];
    }
    const account = await this.msalAuthService.instance.getActiveAccount();
    if (account) {
      const silentRequest = {
        scopes: this.SCOPE,
        account: account,
        forceRefresh: forceFlag
      };

      const request = {
        scopes: this.SCOPE,
        loginHint: account.username // For v1 endpoints, use upn from idToken claims
      };

      try {
        const tokenResponse = await this.msalAuthService.instance.acquireTokenSilent(silentRequest);
        return { accessToken: tokenResponse.accessToken, idToken: tokenResponse.idToken };
      } catch (err) {
        console.log('error details ' + err.name);
        if (err.name === "InteractionRequiredAuthError") {
          try {
            const tokenResponse = await this.msalAuthService.acquireTokenPopup(request).toPromise();
            console.log('token', tokenResponse.accessToken);
            return { accessToken: tokenResponse.accessToken, idToken: tokenResponse.idToken };
          } catch (popupErr) {
            console.error(`401 - Couldn't fetch access token!`);
            throw new Error('401');
          }
        } else {
          throw new Error('401');
        }
      }
    } else {
      console.error('401- Could not fetch access-token, login the user');
      throw new Error('401');
    }
  }
}
